import Draggable from "react-draggable";
import { Token } from "@/components/token.tsx";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { StakedCard } from "./dualstake/components/staked-card";
import { DSContractState } from "@myth-finance/dualstake-ts-sdk";
import { findListingByAsaID, findListingByLstName } from "@/lib/utils";
import { makeDSClient } from "@/lib/clients";
import { WithErrorAndLoading } from "@/components/with-error-and-loading";
import LogoWordmark from "@/assets/myth-horizontal.svg?react";
import { useListings } from "@/hooks/use-listings";

export function AprScreen() {
  const { isPending: loading, error: errorL, data: listings } = useListings();

  const { ids = "" } = useParams();
  const [cStates, setCStates] = useState<DSContractState[]>([]);
  const [error, setError] = useState<string>();

  useEffect(() => {
    (async () => {
      try {
        if (!listings?.size) return;
        const asaListings = ids
          .split(":")
          .map((id) => findListingByLstName(listings, id) || findListingByAsaID(listings, BigInt(id)))
          .filter((e) => e !== undefined);
        if (!asaListings.length) throw new Error("ASA ID not found");
        const cStates = await Promise.all(
          asaListings.map(({ appId: a }) => makeDSClient(a).getState())
        );
        setCStates(cStates);
      } catch (e) {
        console.error(e);
        setCStates([]);
        setError(`While reading dualSTAKE state: ${(e as Error).message}`);
      }
    })();
  }, [listings, ids]);

  return (
    <WithErrorAndLoading loading={loading} error={error ?? errorL}>
      <div className="h-[100svh] flex flex-col gap-12 justify-center items-center relative">
        <div className="absolute top-0 left-[50%] -translate-x-[50%]">
          <Draggable>
            <LogoWordmark className="w-[calc(min(720px,90vw))] opacity-10 cursor-move" />
          </Draggable>
        </div>
        {cStates.map((cState) => (
          <div className="relative">
            <StakedCard showLogo={true} hideAPRInfo={true} cState={cState} listing={cState}/>
            <Draggable>
              <div className="cursor-move">
                <Token
                  hq={true}
                  leftAssetId={Number(cState.asaId)}
                  rightAssetId={0}
                  variant="lg"
                  glowing={true}
                  className="absolute -left-4 -bottom-4"
                />
              </div>
            </Draggable>
          </div>
        ))}
      </div>
    </WithErrorAndLoading>
  );
}
